import { render } from "./Subst.vue?vue&type=template&id=1ba6ff93"
import script from "./Subst.vue?vue&type=script&lang=js"
export * from "./Subst.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pharmarcy/Subst.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ba6ff93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ba6ff93', __exports__)) {
    api.reload('1ba6ff93', __exports__)
  }
  
  module.hot.accept("./Subst.vue?vue&type=template&id=1ba6ff93", () => {
    api.rerender('1ba6ff93', render)
  })

}


export default __exports__